export const addDocumentUrlToMedia = (media) => {
  if (!media) {
    return "";
  }
  return media.externalUrl;
};
